import cn from "../../../utils/cn";
import { PropTypes } from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const TextButton = _ref => {
  let {
    ariaCurrent = "",
    ariaLabel = "",
    children,
    className = "",
    dataTestId = "",
    disabled = false,
    onClick,
    role = undefined
  } = _ref;
  return /*#__PURE__*/_jsx("button", {
    "aria-current": ariaCurrent,
    "aria-label": ariaLabel || children,
    className: cn(className, 'text-action-blue', 'hover:border-dark-border-blue hover:text-text-blue', 'focus:border-dark-border-blue focus:outline-none focus:underline', disabled && 'pointer-events-none opacity-50'),
    "data-testid": dataTestId,
    disabled: disabled,
    onClick: onClick,
    role: role,
    type: "button",
    children: children
  });
};
TextButton.propTypes = {
  ariaCurrent: PropTypes.string,
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  role: PropTypes.string
};
export default TextButton;
//# sourceMappingURL=TextButton.js.map